import {
  deleteMatterItem,
  getMatterItemDetail,
  getMatterItemList,
  saveMatterItem,
} from '../services';

export default {
  namespace: 'matterManagement',
  state: {},
  effects: {
    // 分页展示事项列表
    *getMatterItemList({ payload }, { call }) {
      return yield call(getMatterItemList, payload);
    },

    // 新增、编辑事项
    *saveMatterItem({ payload }, { call }) {
      return yield call(saveMatterItem, payload);
    },

    // 删除事项
    *deleteMatterItem({ payload }, { call }) {
      return yield call(deleteMatterItem, payload);
    },

    // 查看事项详情
    *getMatterItemDetail({ payload }, { call }) {
      return yield call(getMatterItemDetail, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
